(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const media = window.matchMedia('(min-width: 769px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;

    const update = () => {
      ticking = false;
      const sections = document.querySelectorAll('[data-mj-soft-parallax="true"]');

      sections.forEach((section) => {
        if (!media.matches || reducedMotion.matches) {
          section.style.removeProperty('--mj-parallax-y');
          return;
        }

        const rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const clamped = Math.max(0, Math.min(1, progress));
        const offset = (clamped - 0.5) * 70;
        section.style.setProperty('--mj-parallax-y', `${offset.toFixed(1)}px`);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-atelier-header"]) return;
  try {
    
(function() {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let closeTimer;

  function getFocusable(menu) {
    return Array.from(menu.querySelectorAll('summary, nav a')).filter(function(element) {
      return element.offsetParent !== null;
    });
  }

  function openMenu(menu) {
    clearTimeout(closeTimer);
    menu.classList.remove('ma-menu-closing');
    menu.setAttribute('open', '');
    document.documentElement.classList.add('ma-menu-open');
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        menu.classList.add('ma-menu-active');
        const firstLink = menu.querySelector('.ma-mobile-links a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      });
    });
  }

  function closeMenu(menu, restoreFocus) {
    if (!menu) return;
    clearTimeout(closeTimer);
    menu.classList.add('ma-menu-closing');
    menu.classList.remove('ma-menu-active');
    document.documentElement.classList.remove('ma-menu-open');
    const finish = function() {
      menu.removeAttribute('open');
      menu.classList.remove('ma-menu-closing');
      if (restoreFocus) menu.querySelector('summary').focus({ preventScroll: true });
    };
    if (motion.matches) {
      finish();
    } else {
      closeTimer = window.setTimeout(finish, 640);
    }
  }

  document.addEventListener('click', function(event) {
    const summary = event.target.closest('.ma-mobile-menu summary');
    if (summary) {
      event.preventDefault();
      const menu = summary.closest('.ma-mobile-menu');
      if (menu.hasAttribute('open')) closeMenu(menu, true);
      else openMenu(menu);
      return;
    }
    const scrim = event.target.closest('.ma-mobile-scrim');
    if (scrim) closeMenu(scrim.closest('.ma-mobile-menu'), true);
  });

  document.addEventListener('keydown', function(event) {
    const menu = document.querySelector('.ma-mobile-menu[open]');
    if (!menu) return;
    if (event.key === 'Escape') {
      closeMenu(menu, true);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = getFocusable(menu);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
